import { render, staticRenderFns } from "./SideObjectPicture.vue?vue&type=template&id=db77d44a&scoped=true&"
import script from "./SideObjectPicture.vue?vue&type=script&lang=js&"
export * from "./SideObjectPicture.vue?vue&type=script&lang=js&"
import style0 from "./SideObjectPicture.vue?vue&type=style&index=0&id=db77d44a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db77d44a",
  null
  
)

export default component.exports